import { Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useEffect, useRef, useState } from 'react';
import FuelAutoComplete from '../../fuel-autocomplete';

import { DAYS, repeatEndItemList } from '.';
import RepeatEnd from './RepeatEnd';
import { RRule } from 'rrule';

const Weekly = ({ form, onFormChange }) => {
  const [selectedRepeat, setSelectedRepeat] = useState({
    id: 'never',
    name: 'Never',
  });
  const [selectedDays, setSelectedDays] = useState<string[]>(form.getValues('rrule.byweekday') ?? []);
  const handleRepeatChange = (value) => {
    setSelectedRepeat(value);
  };

  const onWeeklyDayClick = (event, id) => {
    event.preventDefault();
    const index = selectedDays.findIndex((w) => w.weekday === id.weekday);
    if (index > -1) {
      const newDays = selectedDays;
      setSelectedDays(newDays.filter((w) => w.weekday !== id.weekday));
    } else {
      setSelectedDays([...selectedDays, id]);
    };
  };

  const getDayCssClass = (id) => {
    const found = selectedDays.find((w) => w.weekday === id.weekday);
    if (selectedDays && selectedDays.includes(id) || found) {
      return 'weekly-round-btn active';
    }
    return 'weekly-round-btn';
  };

  const [untilValue, setUntilValue] = useState(new Date());

  useEffect(() => {
    if (selectedDays && selectedDays.length) {
      form.setValue('rrule.byweekday', selectedDays);
      onFormChange(form);
    }
  }, [selectedDays]);

  useEffect(() => {
    setSelectedDays(form.getValues('rrule.byweekday') ?? []);
  }, [])

  return (
    <>
      <Grid item xs={6}>
        <div className="weekly-repeat-on-days">
          <div className="week-expander-label">Repeat On</div>
          {DAYS.map((day, i) => (
            <button
              key={day.id}
              title={day.name}
              onClick={(event) => onWeeklyDayClick(event, day.id)}
              className={getDayCssClass(day.id)}
            >
              {day.label}
            </button>
          ))}
        </div>
      </Grid>
      <RepeatEnd form={form} onFormChange={onFormChange} />
    </>
  );
};

export default Weekly;
